import React from 'react'
import styled, { keyframes } from 'styled-components'
// @ts-ignore
import { QLogo } from '@netbasequid/core'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
import { SystemTheme } from 'hooks/useUiState/types'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Container = styled.div<{ $fillContainer?: boolean; $theme: SystemTheme }>`
  background-color: ${({ $theme }) => $theme.elevation[100].background};
  height: ${({ $fillContainer }) => ($fillContainer ? '100%' : '100vh')};
  width: ${({ $fillContainer }) => ($fillContainer ? '100%' : '100vw')};
  display: flex;
  justify-content: center;
  align-items: center;
  & svg {
    animation: ${rotate} 1s linear infinite;
  }
`

const ScreenSpinner = ({ fillContainer }: { fillContainer?: boolean }) => {
  const mode = useDisplayTheme()
  const theme = useSysTheme()

  return (
    <Container $fillContainer={fillContainer} $theme={theme}>
      <QLogo fontSize={32} mode={mode} />
    </Container>
  )
}

export default ScreenSpinner
